import { setTerms } from './helpers';

export const setBSCenters = setTerms('bs_center');
